import { Typography } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import React from 'react';
import { H } from '../Layout';

export default function Loading({ size = '32px', center = true, sx = undefined, message = undefined }) {
    return (
        <H
            className={'loading-container'}
            sx={{
                display: 'flex',
                justifyContent: center ? 'center' : 'flex-start',
                alignItems: 'center',
                height: '100%',
                width: '100%',
                ...sx
            }}
        >
            <CircularProgress size={size} />
            {message && <Typography sx={{ p: 3, fontWeight: 600 }}> {message} </Typography>}
        </H>
    );
}
